import { Stage } from "../lusca-search-api/generated-src";

/** Page and API query parameter naming whose personal Dev stack to read. */
export const DEV_USER_PARAM = "user";

/** The `&user=` part of a page link for a Dev stack user, or nothing. */
export const devUserQuery = (user?: string): string =>
  user ? `&${DEV_USER_PARAM}=${encodeURIComponent(user)}` : "";

/**
 * Adds the page's Dev user to a Dev-stage API request URL, so every call made while viewing
 * another user's Dev stack reads that stack. Other stages, other hosts and URLs that already
 * name a user are returned unchanged.
 */
export function withDevUser(
  url: string | undefined,
  apiHost: string | undefined,
  pageSearch: string
): string | undefined {
  if (!url || !apiHost) return url;
  const user = new URLSearchParams(pageSearch).get(DEV_USER_PARAM);
  if (!user) return url;
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }
  if (
    parsed.host !== apiHost ||
    parsed.searchParams.get("stage") !== Stage.Dev ||
    parsed.searchParams.has(DEV_USER_PARAM)
  ) {
    return url;
  }
  const separator = parsed.search ? "&" : "?";
  return `${url}${separator}${DEV_USER_PARAM}=${encodeURIComponent(user)}`;
}
